import { createBrowserHistory } from 'history';

export const redirect = (url) => {
  window.location.href = url;
};

export const browserHistory = createBrowserHistory();
